export default {"src":"/_next/static/media/start.c79ba48b.svg","height":22,"width":30};